// GENERATED — do not edit. Edit the source SVG under svg/air/ and re-run `pnpm build:icons`.
// Source: svg/air/Board.svg

import {
  type IconPaintMode,
  type IconViewBox,
} from "../../../internal/createIconOptions";
import { type IconNode } from "../../../internal/iconNode";

export const paint: IconPaintMode = "stroke";
export const viewBox: IconViewBox = "0 0 24 24";

export const iconNode = [
  [
    "path",
    {
      d: "M3 9H21M9 21V9M5 3H19C20.1046 3 21 3.89543 21 5V19C21 20.1046 20.1046 21 19 21H5C3.89543 21 3 20.1046 3 19V5C3 3.89543 3.89543 3 5 3Z",
    },
  ],
] as const satisfies IconNode;
